export const TEST_ID = 'hotJar';
